module.exports = __webpack_public_path__ + "img/collection-weddingRingsMorningGlow.bd5f609.jpg";